import React, { useRef, useState } from "react";
import './more-about-amc.css';
// componentes y estilos de Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation'; // Si quieres las flechitas
import 'swiper/css/pagination'; // Si quieres los puntitos abajo
// módulos de funcionalidad
import { Navigation, Pagination } from 'swiper/modules';
import { FaLongArrowAltLeft, FaLongArrowAltRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const MoreAboutAmc = () => {
    const cardsData = [
        {
            id: 1,
            title: "NOSOTROS",
            description: "Aeroméxico y Mexicana crean la empresa, donde se concentraría la actividad de carga de ambas aerolíneas.",
            url: "#"
        },
        {
            id: 2,
            title: "ESTACIONES",
            description: "Consulta las estaciones de Aeroméxico a lo largo del territorio mexicano.",
            url: "#"
        },
        {
            id: 3,
            title: "QUEREMOS CUIDAR DE TI",
            description: "Conoce como Aeroméxico Cargo, la operadora de cargas mexicana líder, ofrece 550 vuelos diarios.",
            url: "#"
        },
        {
            id: 4,
            title: "NOSOTROS",
            description: "Aeroméxico y Mexicana crean la empresa, donde se concentraría la actividad de carga de ambas aerolíneas.",
            url: "#"
        },
        {
            id: 5,
            title: "ESTACIONES",
            description: "Consulta las estaciones de Aeroméxico a lo largo del territorio mexicano.",
            url: "#"
        },
        {
            id: 6,
            title: "QUEREMOS CUIDAR DE TI",
            description: "Conoce como Aeroméxico Cargo, la operadora de cargas mexicana líder, ofrece 550 vuelos diarios.",
            url: "#"
        },
    ];

    return(
        <div className="container-fluid more-about-container">
            <div className="row custom-padding-2">
                <div className="col more-about-title">
                    <p>DESCUBRE MÁS DE AEROMÉXICO CARGO</p>
                </div>
            </div>

            <div className="row custom-padding mt-2">
                <div className="col my-4 position-relative">
                
                    <div className="custom-prev-more nav-btn-more">
                        <FaLongArrowAltLeft size={18} />
                    </div>
                    <div className="custom-next-more nav-btn-more">
                        <FaLongArrowAltRight size={18} />
                    </div>

                    <Swiper
                        modules={[Navigation]}
                        spaceBetween={0} // Espacio entre cards (en px)
                        navigation={{
                            nextEl: '.custom-next-more',
                            prevEl: '.custom-prev-more',
                        }}
                        breakpoints={{
                            // Configuración para Celular (>= 320px)
                            320: {
                                slidesPerView: 1, // Muestra 1 card
                                spaceBetween: 10
                            },
                            // Configuración para Tablet (>= 768px)
                            768: {
                                slidesPerView: 3, // Muestra 2 cards (¡Lo que pediste!)
                                spaceBetween: 20
                            }
                        }}
                        className="mySwiper"
                    >
                        {/* Aquí iteramos TODAS las cards, sin separar en grupos */}
                        {cardsData.map((card, index) => (
                            <SwiperSlide key={index} style={{ height: 'auto' }}>
                                {/* El 'height: auto' en el slide es clave para que Flexbox funcione dentro */}
                                <div className="card-more-about"> 
                                    <div className="mb-0">
                                        <div className="card-more-about-title">
                                            <h5>{card.title}</h5>
                                        </div>
                                        <div className="card-more-about-text">
                                            <p>{card.description}</p>
                                        </div>
                                    </div>
                                    <Link to={card.url} className="btn-transparent mt-3 text-decoration-none">
                                        Descubre más
                                    </Link>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    );
}

export default MoreAboutAmc;